<template>
  <div class="slider-topic flex flex-wrap pb-6 md:pb-8">
    <div class="w-full">
      <h3 class="tracking-wider text-center mb-0 py-5 lg:py-8 text-lg lg:text-xl text-NotoSansBold textColorBlack">主題專欄</h3>
    </div>
    <!-- <div class="w-full flex flex-wrap">
      <div class="w-1/3" v-for="(item, index) in articleData" :key="index" ref="sliderTopic">
        <div class="slider-topic-content">
          <router-link :to="{name: 'topicDetail', params: { id: item.id }}">
            <div class="m-1 md:m-2 lg:m-4 slider-topic-inner relative animated">
              <div class="square-topic border">
                <div v-if="item.cover_url" class="square-img" :style="{'background-image': 'url(' + articleData[index].cover_url + ')' }"></div>
                <div v-else class="square-img square-img-none"></div>
              </div>
              <div class="slider-topic-inner-magazine w-full absolute px-8 sm:px-10 hidden lg:block">
                <p class="mb-0 text-sm text-NotoSansRegular">{{ moment(articleData[index].publish_at).format('YYYY.MMM.DD') }}</p>
              </div>
              <div class="w-full px-8 md:px-10 slider-topic-inner-text absolute hidden lg:block">
                <div class="border-b">
                  <p class="mb-0 mt-2 text-NotoSansRegular text-base">{{ articleData[index].title }}</p>
                </div>
              </div>
            </div>
              <div class="w-full px-2 slider-topic-inner-text lg:hidden">
                <p class="mb-0 text-xs text-NotoSansRegular">{{ moment(articleData[index].publish_at).format('YYYY.MMM.DD')}}</p>
                <p class="mb-3 text-NotoSansRegular font-semibold text-base mobile-title">{{ articleData[index].title }}</p>
              </div>
          </router-link>
        </div>
      </div>
    </div> -->
    <div class="article">
      <div class="page-content pb-6 md:pb-8 text-NotoSansRegular">
      <div class="card" v-for="(item, index) in articleData" :key="index" v-lazy:background-image="{ src: articleData[index].cover_url }">
          <div class="content tracking-wider">
          <p class="text-sm text-NotoSansLight">{{ moment(articleData[index].publish_at).format('YYYY.MMM.DD') }}</p>
          <h2 class="title font-bold text-base">{{ articleData[index].title }}</h2>
          <router-link :to="{ name: 'topicDetail', params: { id: item.id }}" class="view-btn">View</router-link>
          </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    articleData: {
      type: Array
    }
  },
  methods: {
    setArticle () {
      let self = this
      if (self.$refs.sliderTopic) {
        for (let idx of self.$refs.sliderTopic.keys()) {
          if (idx < 2) {
            self.$refs.sliderTopic[idx].classList.add('md:w-1/2')
          } else {
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .slider-topic {
    h3 {
      padding-top: 3rem;
      padding-bottom: 1.6rem;
    }
    .slider-topic-content {
      // big
      .slider-topic-inner {
        .square-topic {
          position: relative;
          width: 100%;
          padding-bottom : 100%;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          background-color: transparent;
          background-origin: padding-box;
          .square-img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            padding-bottom : 100%;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
          }
          .square-img-none {
            background-image: url('~@/assets/images/preset_item.png');
          }
        }
        .slider-topic-inner-magazine {
          top: 8%;
          z-index: 2;
          p {
            text-align: right;
            font-weight: 400;
            color: #ffffff;
          }
        }
        .slider-topic-inner-text {
          bottom: 8%;
          z-index: 2;
          p {
            color: #ffffff;
            line-height: 24px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
      .animated:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0px;
        right: 0px;
        background: rgba(0, 0, 0, 0.5);
        height: 100%;
        z-index: 1;
        transition: .2s;
      }
      .animated:hover:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0px;
        right: 0px;
        background: rgba(0, 0, 0, 0.2);
        height: 100%;
        z-index: 1;
      }
      @media (max-width: 1024px) {
        .animated:after {
          background: rgba(0, 0, 0, 0);
        }
        .animated:hover:after {
          background: rgba(0, 0, 0, 0);
        }
      }
      .mobile-title {
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
      }
    }
  }

  // test
  $imageIds: '1517021897933-0e0319cfbc28', '1533903345306-15d1c30952de', '1545243424-0ce743321e11', '1531306728370-e2ebd9d7bb99';

  $bp-md: 768px;
  $bp-lg: 1040px;

  :root {
    --d: 700ms;
    --e: cubic-bezier(0.19, 1, 0.22, 1);
  }

.article {
  .page-content {
    display: grid;
    grid-gap: 1rem;
    padding: 1rem;
    margin: 0 auto;

    @media (min-width: $bp-md) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: $bp-lg) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  .card {
    position: relative;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
    padding: 1rem;
    width: 100%;
    text-align: center;
    color: whitesmoke;
    background-color: whitesmoke;
    height: 18em;

    @media (min-width: $bp-md) {
      height: 25em;
    }
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 110%;
      background-size: cover;
      background-position: center;
      transition: transform calc(var(--d) * 1.5) var(--e);
      pointer-events: none;
      background-image: inherit;
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 200%;
      pointer-events: none;
      background-image: linear-gradient(
        to bottom,
        hsla(0, 0%, 0%, 0) 0%,
        hsla(0, 0%, 0%, 0.009) 11.7%,
        hsla(0, 0%, 0%, 0.034) 22.1%,
        hsla(0, 0%, 0%, 0.072) 31.2%,
        hsla(0, 0%, 0%, 0.123) 39.4%,
        hsla(0, 0%, 0%, 0.182) 46.6%,
        hsla(0, 0%, 0%, 0.249) 53.1%,
        hsla(0, 0%, 0%, 0.320) 58.9%,
        hsla(0, 0%, 0%, 0.394) 64.3%,
        hsla(0, 0%, 0%, 0.468) 69.3%,
        hsla(0, 0%, 0%, 0.540) 74.1%,
        hsla(0, 0%, 0%, 0.607) 78.8%,
        hsla(0, 0%, 0%, 0.668) 83.6%,
        hsla(0, 0%, 0%, 0.721) 88.7%,
        hsla(0, 0%, 0%, 0.762) 94.1%,
        hsla(0, 0%, 0%, 0.9) 100%
      );
      transform: translateY(-50%);
      transition: transform calc(var(--d) * 2) var(--e);
    }
  }

  .content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 1rem;
    transition: transform var(--d) var(--e);
    z-index: 1;
    > * + * {
      margin-top: 1rem;
    }
  }

  .copy {
    font-size: 1.125rem;
    font-style: italic;
    line-height: 1.35;
  }

  .view-btn {
    cursor: pointer;
    margin-top: 1.5rem;
    padding: 0.75rem 1.8rem;
    font-size: 0.65rem;
    font-weight: bold;
    letter-spacing: 0.025rem;
    text-transform: uppercase;
    color: white;
    background-color: #e60012;
    border: none;
    transition: .2s !important;

    &:hover {
      background-color: #484848;
    }
  }

  @media (hover: hover) and (min-width: $bp-md) {
    .card:after {
      transform: translateY(0);
    }

    .content {
      transform: translateY(calc(100%));

      > *:not(.title) {
        opacity: 0;
        transform: translateY(1rem);
        transition:
          transform var(--d) var(--e),
          opacity var(--d) var(--e);
      }
    }

    .card:hover,
    .card:focus-within {
      align-items: center;

      &:before {
        transform: translateY(-4%);
      }
      &:after {
        transform: translateY(-50%);
      }

      .content {
        transform: translateY(0);
        > *:not(.title) {
          opacity: 1;
          transform: translateY(0);
          transition-delay: calc(var(--d) / 8);
        }
      }
    }

    .card:focus-within {
      &:before,
      &:after,
      .content,
      .content > *:not(.title) {
        transition-duration: 0s;
      }
    }
  }
}
  .card[lazy=loading] {
    background-image: none !important;
  }
</style>
